import { axios } from 'lib/axios';
import { queryClient } from 'lib/react-query';
import { useNotificationStore } from 'stores/notifications';
import PropTypes from 'prop-types';
import { useMutation } from 'react-query';

export const joinNewsletter = ({ data }) => {
  return axios.post(`/newsletter/subscribe`, data);
};

export const useJoinNewsletter = ({ config } = {}) => {
  const { addNotification } = useNotificationStore();
  return useMutation({
    onMutate: async (newAlumni) => {
      },
    onError: (_, __, context) => {
      },
    onSuccess: () => {
      
    },
    ...config,
    mutationFn: joinNewsletter,
  });
};
